import { PETS_API_URL } from "@/constants";

import { createFetcher } from "../client/fetcher";

type Breed = {
  id: number;
  name: string;
};

const fetcher = createFetcher();

export async function getBreeds(species: number) {
  const { data, status } = await fetcher
    .get<Breed[]>(`${PETS_API_URL}/breeds?species=${species}`)
    .catch((err) => ({
      data: null,
      status: err.status as number,
    }));

  return {
    data,
    status,
  };
}
